import React from "react";

export type StoreBase<TProps extends object> = {
	init?: () => void
	destroy?: () => void
	props?: TProps
}

export type UseStoreExtra<TProps> = {
	props?: TProps,
	deps?: any[]
}

export function useStore<TProps extends object, TStore extends StoreBase<TProps>>(createFunction: () => TStore, extra?: UseStoreExtra<TProps>) {
	const initializedRef = React.useRef(false)
	const firstRenderRef = React.useRef(true)
	const [store, setStore] = React.useState(createFunction)

	const fillProps = () => {
		if (extra?.props) {
			if(store.props == null){
				store.props = {} as TProps;
			}
			Object.assign(store.props, extra.props)
		}
	}

	React.useEffect(() => {
		let newStore = store

		if (initializedRef.current == false && firstRenderRef.current == false) {
			newStore = createFunction()
			setStore(newStore)
		}

		if (initializedRef.current == false) {
			// fill props to have it in init method
			fillProps();
			newStore.init?.()
		}

		firstRenderRef.current = false

		return () => {
			newStore.destroy?.()
			initializedRef.current = false
		}
	}, extra?.deps ?? [])

	const deps = extra?.props ? Object.values(extra.props) : []
	deps.push(store)

	React.useEffect(() => {
		fillProps();
	}, deps)

	return store
}
